import {
  GraphQLJSON,
  IntegrationSyncResultIntegrationType,
  TelematicsIntegrationDiagnosticStatus,
} from '../lib/graphql';

export const integrationTypeLabelMap: Record<string, string> = {
  PULL: 'Pull integration',
  STANDARD_PUSH: 'Standard push integration',
  CUSTOM_PUSH: 'Custom push integration',
  CUSTOM: 'Custom integration',
  FTP: 'FTP',
};

export const formatIntegrationType = (value: string): string => integrationTypeLabelMap[value] ?? value;

export interface UserProfile {
  user_id: string;
  first_name: string | null;
  last_name: string | null;
}

interface ConflictingLicensePlate {
  licensePlate: string | null;
  remoteIds: string[] | null;
}

interface ConflictingRemoteId {
  remoteId: string | null;
  licensePlates: string[] | null;
}

export interface IntegrationSyncHistory {
  startTimeAt: string;
  endTimeAt: string;
  vehicleCount: number | null;
  statusCount: number | null;
  temperatureCount: number | null;
  distinctVehicleStatusFutureCount: number | null;
  distinctVehicleTemperatureFutureCount: number | null;
  distinctVehicleNullIslandCount: number | null;
  vehicleAmbiguityCount: number | null;
  latestStatusTimestamp: string | null;
  latestTemperatureTimestamp: string | null;
  errorDescription: string | null;
  errorType: string | null;
  resultType: string | null;
  conflictingLicensePlates: ConflictingLicensePlate[] | null;
  conflictingRemoteIds: ConflictingRemoteId[] | null;
  integrationType: IntegrationSyncResultIntegrationType | null;
  tourPositionsCount: number | null;
  stopEventsCount: number | null;
  tourEventsCount: number | null;
  tourAllocationsCount: number | null;
}

export interface TelematicIntegration {
  telematics_integration_id: string;
  telematics_provider_id: string;
  company_integration_id: string;
  company_id: string;
  connection_data?: GraphQLJSON | null;
  enabled: boolean;
  telematicsProvider: {
    isDeprecated: boolean | null;
    isVehicleManagementEnabled: boolean | null;
    connectionParameters: {
      fieldName: string;
      fieldType: string;
      isOptional: boolean;
      isInternal: boolean;
      isSensitive: boolean;
      fieldDisplayName: string | null;
      enumFieldValues: {
        value: string;
        display_name?: string | null;
        is_default: boolean;
      }[];
    }[];
  } | null;
  diagnosticStatus: TelematicsIntegrationDiagnosticStatus | null;
  diagnosticComment?: string | null;
  createdAt: string;
  updatedAt: string;
  company: {
    company_id: string;
    company_name: string | null;
  };
  isImmutable: boolean;
  isDeletable: boolean;
  integrationApiDebugUrl: string;
  integrationApiDebugWithSyncStateUrl: string;
  integrationSyncHistory?: IntegrationSyncHistory[] | null;
  createdBy: UserProfile | null;
  updatedBy: UserProfile | null;
  totalTrucksCount: number;
  activeTrucksCount: number;
  recentAllocationsCount: number;
}
